import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Links */}
          <div>
            {mockData.footerLinks.company.map((link) => (
              <Link
                key={link.name}
                to={link.link}
                className="block text-gray-600 hover:text-orange-500 mb-2 transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Legal Links */}
          <div>
            {mockData.footerLinks.legal.map((link) => (
              <Link
                key={link.name}
                to={link.link === '/locations' ? link.link : '#'}
                className="block text-gray-600 hover:text-orange-500 mb-2 transition-colors duration-200"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Social */}
          <div>
            <a 
              href="https://www.linkedin.com/company/ambrosiafoods" 
              className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              LinkedIn
            </a>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-2xl font-bold text-orange-500 mb-4 md:mb-0">
            <span className="italic">ambrosia</span>
          </div>
          <p className="text-gray-500 text-sm">
            © 2025 Ambrosia Foods. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;